import React, { useContext, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { observer } from "mobx-react";
import QRCode from "qrcode.react";
import { Popover } from "antd";
import DetailGraph from "./DetailGraph";
import { triggerLogin } from "../../utils/trigger";

import "./style.scss";
import {
  ArticleLayout,
  ArticleNav,
  Loading,
} from "../../components/shared/index";
import { Icon, Notify } from "../../components";
import HomeList from "../home/HomeList";
import DetailProgress from "./DetailProgress";
import authStore from "../../stores/authStore";
import articleStore from "../../stores/articleStore";
import { isMobile } from "../../utils/tools";

const Detail: React.FC = () => {
  const { id } = useParams();
  const skip = new URLSearchParams(useLocation().search).get("skip"); // 获取 skip 参数
  const { isLogin, isMember, setDialog } = useContext(authStore);
  const {
    setOpenName,
    showList,
    setShowList,
    loading,
    detailLoading,
    detail,
    fetchDetail,
    onUpdateLike,
    // similarList,
    // onUpdateSimilar,
  } = useContext(articleStore);
  const [percent, setPercent] = useState(0);
  const [directoryList, setDirectoryList] = useState([]);
  const activeEl = document.querySelector(
    ".article-card--active"
  ) as HTMLElement | null;
  const scrollEl = document.querySelector(
    ".home__list-scroll"
  ) as HTMLElement | null;
  const listEl = document.querySelector(
    ".home__list--detail"
  ) as HTMLElement | null;

  const hasMark = (text: string): boolean => {
    // 匹配包含至少一个"data-"属性且完整闭合的mark标签
    return /<mark\s+[^>]*data-\w+\s*=[^>]*>.*?<\/mark>/.test(text);
  };

  const onScrollEvent = () => {
    const pageEl = document.querySelector(".detail__content");
    const infoEl = document.querySelector(".detail__info");
    const similarEl = document.querySelector(
      ".detail__similar-mobile"
    ) as HTMLElement | null;
    const progressEl = document.querySelector(
      ".detail__progress-wrapper"
    ) as HTMLElement | null;
    // 获取当前滚动位置
    const scrollTop = pageEl.scrollTop;
    // 获取页面总高度和视口高度、移动端推荐文章高度
    const scrollHeight = infoEl.scrollHeight;
    const clientHeight = pageEl.clientHeight;
    const similarHeight = isMobile() && similarEl ? similarEl.offsetHeight : 0;
    // 计算滚动进度百分比
    const progress =
      (scrollTop / (scrollHeight + similarHeight - clientHeight)) * 100;
    // 更新进度条宽度
    setPercent(Math.round(progress));
    // 滚动到指定位置显示遮罩
    if (scrollTop > 128) {
      // opacity 在 ts 的 CSSStyleDeclaration 里被定义成 string 类型
      progressEl.style.opacity = "1";
    } else {
      progressEl.style.opacity = "0";
    }
  };

  //去掉字符串两端的空格
  function trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
  }
  //去除换行
  function ClearBr(key) {
    key = key.replace(/<\/?.+?>/g, "");
    key = key.replace(/[\r\n]/g, "");
    return key;
  }

  const getAlls = () =>
    Array.from(document.querySelectorAll(`.detail__info-body *`)).filter(
      (item: HTMLElement) => !!ClearBr(trim(item.innerText))
    );

  const getH3s = () =>
    Array.from(document.querySelectorAll(`.detail__info-body h3`)).filter(
      (item: HTMLElement) => !!ClearBr(trim(item.innerText))
    );

  // const getSections = () =>
  //   Array.from(document.querySelectorAll(`.detail__info-body section`)).filter(
  //     (item: HTMLElement) => !!ClearBr(trim(item.innerText))
  //   );

  const initSectionItem = h3s => {
    if (h3s.length > 0) {
      h3s.forEach((item: any, index: number) => {
        item._type = "h3";
        item._index = index;
      });
    }
    return h3s;
  };

  useEffect(() => {
    fetchDetail(id);
  }, [id]);

  useEffect(() => {
    const jumpType = window.sessionStorage.getItem("jumpType"); // 官网首页 || 文章库列表跳转标识
    if (listEl) {
      listEl.classList.contains("home__list-transition") &&
        listEl.classList.remove("home__list-transition"); // 移除过渡效果
      /**
       * 区分跳转链路：
       * 1.指定页面：滚动前，不显示列表
       * 2.非指定页面：显示列表
       */

      // opacity 在 ts 的 CSSStyleDeclaration 里被定义成 string 类型
      listEl.style.opacity =
        jumpType && jumpType === "list" && showList ? "0" : "1";

      if (jumpType && !loading && activeEl && scrollEl) {
        // 滚动到当前详情对应位置
        scrollEl.scrollTop = activeEl.offsetTop;
        // 文章库列表标识清除（官网首页在其他地方清除）
        jumpType === "list" && window.sessionStorage.removeItem("jumpType");
        // 滚动完成后，再显示列表
        listEl.classList.add("home__list-transition"); // 添加过渡效果
        listEl.style.opacity = "1";
      }
    }
  }, [loading, activeEl, scrollEl, showList]);

  useEffect(() => {
    if (!detailLoading) {
      const alls = getAlls();
      alls.forEach((item: any, index: number) => (item.sort = index));
      const h3s = getH3s();
      setDirectoryList(initSectionItem(h3s));
      // 获取 name="description" 的 meta 标签
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      // 获取 name="keywords" 的 meta 标签
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (detail.seo && metaDescription) {
        // 将 content 替换为指定值
        detail.seo.des &&
          metaDescription.setAttribute("content", detail.seo.des);
        detail.seo.keywords &&
          metaKeywords.setAttribute("content", detail.seo.keywords.join("，"));
      }
    }
  }, [detailLoading]);

  useEffect(() => {
    const pathname = window.sessionStorage.getItem("articlePath");
    setShowList(!!pathname);
  }, [window.sessionStorage.getItem("articlePath")]);

  return (
    <div className="detail" onClick={() => setOpenName("")}>
      <Helmet>
        <title>{detail.title || "文章库"} ｜ 机器之心</title>
      </Helmet>
      <ArticleLayout>
        <ArticleNav />
        <div className="detail__content-wrapper">
          <div
            className="detail__content"
            onScrollCapture={onScrollEvent}
            onClick={() => {
              if (!isLogin || !isMember) {
                if (isLogin) {
                  skip !== "1" && setDialog("buyVip", true);
                } else {
                  triggerLogin();
                }
              }
            }}
          >
            <DetailProgress
              position={showList}
              detail={detail}
              percent={percent}
              list={directoryList}
              getH3s={getH3s}
            />
            {!isMobile() && <HomeList type="detail" />}
            <div
              className={`detail__info ${!isMobile() &&
                !showList &&
                "pad-left0"}`}
            >
              {/* 遮罩，防止触发详情点击事件 */}
              {(!isLogin || !isMember) && (
                <div className="detail__info__layer" />
              )}
              {detailLoading ? (
                <Loading />
              ) : (
                <>
                  <div className="detail__info-header">
                    {detail.author && (
                      <div className="detail__info-author">
                        <img src={detail.author.avatar_url} alt="avatar" />
                        <div className="detail__info-author-info">
                          <div>
                            {detail.author.name}
                            {detail.copyright && <p>{detail.copyright}</p>}
                          </div>
                          {detail.publishTime && (
                            <p className="detail__info-date">
                              {detail.publishTime}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                    {detail.title && (
                      <p className="detail__info-title">{detail.title}</p>
                    )}
                    {/* {detail.description && (
                      <p className="detail__info-summary">
                        {detail.description}
                      </p>
                    )} */}
                  </div>
                  {/* 根据是否包含mark标签，决定是否使用组件转换 */}
                  {/* {hasMark(detail.content) ? (
                    <DetailGraph
                      className="detail__info-body"
                      content={detail.content}
                    />
                  ) : (
                    <div
                      className="detail__info-body"
                      dangerouslySetInnerHTML={{
                        __html: `${detail.content}`,
                      }}
                    />
                  )} */}
                  <div
                    className="detail__info-body"
                    dangerouslySetInnerHTML={{
                      __html: `${detail.content}`,
                    }}
                  />
                  <div className="detail__info-action">
                    <div
                      className={`detail__info-zan ${detail.liked &&
                        "detail__info-zan--liked"}`}
                      onClick={() => {
                        if (window.currentUser) {
                          onUpdateLike(id, detail.liked);
                        } else {
                          triggerLogin();
                        }
                      }}
                    >
                      <Icon name="love" size={24} />
                      <Icon name="love-fill" size={24} />
                      {!!detail.likes_count ? detail.likes_count : ""}
                    </div>
                    {isMobile() ? (
                      <div
                        className="detail__info-share"
                        onClick={() => {
                          if (navigator.clipboard && window.isSecureContext) {
                            // 使用 navigator.clipboard.writeText 复制
                            navigator.clipboard
                              .writeText(window.location.href)
                              .then(() => {
                                Notify.success({
                                  message: "链接复制成功！",
                                  className: "notify-not-description",
                                  duration: 3,
                                });
                              })
                              .catch(err => {
                                Notify.error({
                                  message: `复制失败：${err}`,
                                  duration: 3,
                                });
                              });
                          } else {
                            // 兼容性回退：使用 document.execCommand
                            const textarea = document.createElement("textarea");
                            textarea.value = window.location.href;
                            textarea.style.position = "fixed";
                            textarea.style.left = "-999999px";
                            document.body.appendChild(textarea);
                            textarea.select();

                            try {
                              const success = document.execCommand("copy");
                              if (success) {
                                Notify.success({
                                  message: "链接复制成功！",
                                  className: "notify-not-description",
                                  duration: 3,
                                });
                              } else {
                                Notify.error({
                                  message: "复制失败，请检查浏览器支持性。",
                                  duration: 3,
                                });
                              }
                            } catch (err) {
                              Notify.error({
                                message: `复制失败：${err}`,
                                duration: 3,
                              });
                            } finally {
                              document.body.removeChild(textarea);
                            }
                          }
                        }}
                      >
                        <Icon name="share" size={24} />
                      </div>
                    ) : (
                      <Popover
                        content={
                          <div className="share-ways">
                            <QRCode value={window.location.href} size={85} />
                            <p>微信扫码分享</p>
                          </div>
                        }
                        trigger="hover"
                        getPopupContainer={() =>
                          document.querySelector(".detail__info") ||
                          document.body
                        }
                      >
                        <div className="detail__info-share">
                          <Icon name="share" size={24} />
                          <Icon name="share-fill" size={24} />
                        </div>
                      </Popover>
                    )}
                  </div>
                  {/* {!isMobile() && similarList && similarList.length > 0 && (
                    <div className="detail__similar">
                      <p>推荐文章</p>
                      <div className="detail__similar__list">
                        {similarList.slice(0, 3).map((item) => (
                          <div className="detail__similar__item" key={item.id}>
                            <div
                              className="detail__similar__img"
                              onClick={() =>
                                window.open(`/articles/${item.id}`, "_black")
                              }
                            >
                              <img src={item.cover_image_url} alt="coverImg" />
                            </div>
                            <div
                              className="detail__similar__title"
                              onClick={() =>
                                window.open(`/articles/${item.id}`, "_black")
                              }
                            >
                              {item.title}
                            </div>
                            <div className="detail__similar__footer">
                              <div
                                className="detail__similar__author"
                                onClick={() =>
                                  window.open(
                                    `/users/${item.author_id}`,
                                    "_black"
                                  )
                                }
                              >
                                <img
                                  src={item.author_avatar_url}
                                  alt="author"
                                />
                                {item.author}
                              </div>
                              <div
                                className={`detail__similar__zan ${item.liked &&
                                  "detail__similar__zan--liked"}`}
                                onClick={() => {
                                  if (window.currentUser) {
                                    onUpdateSimilar(item.id, item.liked);
                                  } else {
                                    triggerLogin();
                                  }
                                }}
                              >
                                <Icon name="love" size={18} />
                                <Icon name="love-fill" size={18} />
                                {!!item.likes_count ? item.likes_count : ""}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )} */}
                </>
              )}
            </div>
            {/* {isMobile() && similarList && similarList.length > 0 && (
              <div className="detail__similar-mobile">
                <p>推荐文章</p>
                {similarList.slice(0, 3).map((item) => (
                  <div
                    className="detail__similar__item"
                    key={item.id}
                    onClick={() =>
                      window.open(`/articles/${item.id}`, "_black")
                    }
                  >
                    <div className="detail__similar__title">{item.title}</div>
                    <div className="detail__similar__content">
                      {item.content}
                    </div>
                    <div className="detail__similar__bottom">
                      <div className="detail__similar__time">
                        {item.publishTime}
                      </div>
                      {item.tag_list && item.tag_list.length > 0 && (
                        <div className="detail__similar__tags">
                          {item.tag_list.map((tag, index) => (
                            <div key={index}>{tag}</div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )} */}
          </div>
        </div>
      </ArticleLayout>
    </div>
  );
};

export default observer(Detail);
